import { IFloor } from './interfaces/iFloor.interface';

export class Variant {
    id: number;
    name: string;
    wagonId: number;
    floors: Array<IFloor>;
    floor1Base64String:string;
    floor2Base64String:string|null;
    hasCollissions:boolean;
    floor1CeilingBase64String:string;
    floor2CeilingBase64String:string|null;

    constructor() {
        this.floors = new Array();
    }
}